import StepDocuments from './StepDocuments.component';

export default StepDocuments;
